import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_stipend_course",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "add_job",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_stipend_course_button",
  "data-kt-drawer-close": "#kt_drawer_stipend_course_close",
  "data-kt-drawer-width": "65.5vw"
}
const _hoisted_2 = {
  id: "kt_drawer_stipend_course",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_drawer_stipend_course_header\"><h2 class=\"fw-bolder text-light my-auto\">Eligible Courses</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_stipend_course_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body p-2",
  id: "kt_drawer_stipend_course_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_drawer_stipend_course_body",
  "data-kt-scroll-dependencies": "#kt_drawer_stipend_course_header, #kt_drawer_stipend_course_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "card mb-5 mb-xl-10" }
const _hoisted_6 = {
  class: "table mx-5 mt-5 w-auto",
  style: {"border":"1px solid #7da17d, width: 98% !important"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1px solid #a78951"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center bg-success text-white",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " SL "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Course Name "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Course Code ")
], -1)
const _hoisted_8 = { style: {"border-bottom":"1px solid #9ee29e"} }
const _hoisted_9 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_10 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (data, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "bg-light",
                  style: {"border-left":"1px solid #a78951"}
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(data?.course_name), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(data?.code), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}